import React, { useEffect } from "react";
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import RelatedWorks from "./RelatedWorks";
import "./Mgrdetail.css";

export default function DeyeDetails() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="work-detail-page">
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 1000 }}>
        <Navbar />
      </div>

      <section className="project-info-section">
        <h1 className="project-title-heading">
          Deye
        </h1>

        <p className="project-description">
          We partnered with Deye to design and develop their corporate marketing collaterals, delivering premium product brochures and high-impact promotional flyers. Our creative process focused on translating Deye's sophisticated solar inverters and battery technology into clean, structured print layouts that build trust with global distributors and retail consumers.
        </p>

        <div className="project-tags">
          <span className="info-tag">Brochure Design</span>
          <span className="info-tag">Flyer Design</span>
        </div>
      </section>

      {/* Full landscape image */}
      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Deye/Full1.webp" style={{minHeight:"930px"}} alt="Deye Solar Solutions Showcase" />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We crafted a premium, high-quality brochure system for Deye, translating their smart energy solutions and technical inverter specifications into a beautifully structured, tactile print layout."
        </div>
      </section>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Deye/Full2.webp" alt="Deye Solar Solutions Showcase" />
      </div>

      {/* Quote text below the images */}
      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "Every page of the Deye product brochure was designed to project engineering excellence and build customer trust, maintaining absolute brand consistency across technical diagrams and color schemes."
        </div>
      </section>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Deye/Full3.webp" alt="Deye Solar Solutions Showcase" />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "Our team designed high-impact promotional flyers for Deye, engineered to capture attention at global trade shows and solar exhibitions with clean typography and strong visual call-outs."
        </div>
      </section>

     
      <RelatedWorks excludePath="/works/deye" />
      <Footer />
    </div>
  );
}
